var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge-offer"},[_vm._v(_vm._s(_vm.$t('message.detail.badges.offer'))+" "),_c('span',{staticClass:"percentage-text"},[_vm._v(_vm._s(_vm.offerPercentageString))])])}
var staticRenderFns = []

export { render, staticRenderFns }